module.exports = __webpack_public_path__ + "img/Fin V2.aef15e5b.jpg";